module.exports = __webpack_public_path__ + "static/media/droplet.9cdc7269.svg";